import BaseSelect from "component/select/BaseSelect";
import { useGraphicOrganizerHook } from "hooks/content/useGraphicOrganizerHook";
import { useEffect } from "react";

/**
 * Form Input Web Address Props
 * 
 * @param {BaseContentFormProps & {
 *  id: string
 *  graphor_type: number
 * }} props
 */
export default function FormInputGraphicOrganizer({ 
  value, 
  setValue, 
  isInvalid, 
  isRequired, 
  errorMessage,
  isInitSelectedValueFromFormSelect,
  id,
  graphor_type,
}) {
  const { data, handler, } = useGraphicOrganizerHook()

  /**
   * Set Init Select Value
   * 
   * @param {Array<BaseSelectFormatData>} listOptions 
   */
  const setInitSelectValue = (listOptions) => {
    if (isInitSelectedValueFromFormSelect && Array.isArray(listOptions) && listOptions.length) {
      const isValueExist = listOptions.find(opt => opt.value === id)

      if (isValueExist) {
        setValue(isValueExist)
      }
    }
  }

  useEffect(() => {
    handler.getGraphicOrganizerHandler({ setInitSelectValue, graphor_type })
  }, [])

  return (
    <div className="form-group mb-5 row">
      <label className="col-sm-3 col-form-label" htmlFor='inputGraphicOrganizer'>
        <span className="mr-1">Graphic Organizer</span>
        {isRequired
        ?
          <span className="text-danger">*</span>
        : null }
      </label>
      <div className="row col-sm-9">
        <div className="col-sm-8">
          <BaseSelect
            isSearchable={true}
            isMulti={false}
            onMenuOpen={() => handler.getGraphicOrganizerHandler({ graphor_type })}
            placeholder="Pilih Graphic Organizer"
            noOptionsMessage={() => 'Data graphic organizer tidak dtemukan'}
            isClearable={true}
            options={data.listGraphicOrganizer.optionsFilter}
            value={value}
            onChange={setValue}
          />

          {isInvalid ? (
            <label className="small form-text text-danger">
              {errorMessage || 'Graphic Organizer tidak boleh kosong.'}
            </label>
          ) : null}
        </div>

        <div className="col-sm-4">
          <button
            type="button"
            className="btn btn-primary btn-sm mt-2 mt-md-1"
            onClick={handler.popUpWindowKelolaGraphicOrganizerHandler}
          >
            <i className="feather icon-settings mr-1" />
            <span>Kelola Graphic Organizer</span>
          </button>
        </div>
      </div>
    </div>
  )
}